
<template>
  <v-form :readonly="is_readonly">
    <v-text-field prepend-icon="mdi-information" required v-model="main_data.name" label="Nome" :rules="required" type="text"></v-text-field>
    <v-text-field prepend-icon="mdi-email" required v-model="main_data.email" label="E-mail" :rules="required" type="text"></v-text-field>
    <!-- <v-text-field prepend-icon="mdi-information" required v-model="main_data.title" label="Nome" :rules="required" type="text"></v-text-field> -->
    <!-- <v-text-field prepend-icon="mdi-information" required v-model="main_data.title" label="Nome" :rules="required" type="text"></v-text-field> -->
    <v-row align="center" v-if="false">
      <v-col class="py-0" v-if="!is_readonly">
        <v-file-input v-model="main_data.file" counter show-size truncate-length="29" label="Selecione o arquivo" accept="user/*" ></v-file-input>
      </v-col>
      <v-col class="py-0" v-if="is_readonly">
        
      </v-col>
      <v-col cols='4'>
        <v-row align="center">
          <v-col class="pa-0">
            <v-text-field required v-model="main_data.min" label="Min" :rules="required_min" type="number" min="0"></v-text-field>
          </v-col>
          <v-col cols='1'>
            <div class="title">:</div>
          </v-col>
          <v-col class="pa-0">
            <v-text-field required v-model="main_data.sec" label="Seg" :rules="required_seconds" min="0" max="59" type="number"></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    
    <template>
      <v-alert type="info" v-if="loading_users || loading_depts" :value="true">
        Carregando...
        <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
      </v-alert>
    </template>


    <!-- <v-container class="d-flex justify-center">
      <v-btn disabled color="primary">Selecionar Documento</v-btn>
    </v-container> -->
  </v-form>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import {mask} from 'vue-the-mask'
import validations from "@/mixins/validations";
import Api from '@/api'

export default {
  name: 'MainData',
  mixins: [ validations ],
  directives: { mask },
  props: {
    main_data: {
      type: Object,
    },
    is_readonly:{
      type: Boolean,
      default: () => false
    },
    preview: {
      type: [Object, String]
    }
  },
  data() {
    return {
      key: null,
      store_id: null,

      active: [],
      open: [],

      loading_users: false,
      loading_depts: false,
      departments: null,
      
    }
  },
  mounted () {
    this.getUsers();
    if (this.main_data.store_id) {
      this.getUserDepartments(this.main_data.store_id)
    }
  },
  methods: {
    getUsers() {
      if (!this.all_users || !this.all_users.length){
        this.loading_users = true
        this.indexUsers().then(()=>{
          this.loading_users = false
        })
      }
    },
    getUserDepartments(store_id){
      this.loading_depts = true
      Api.Department.indexByModel({id: store_id}).then(r=> r.data).then(d=> {
        this.departments = [...d[0][0].children]
      }).catch((err) => {
        console.log(err);
      }).finally(()=>{
        this.loading_depts = false
      })
    },
    ...mapActions({
      indexUsers: 'User/index'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      all_users: state=> state.User.all_users
    })
  },
  watch: {
    'main_data.store_id'(nv,ov) {
      if (nv){
        this.main_data.department_id = []
        this.getUserDepartments(nv)
      } else if (nv == false){
      }
    },
    'main_data.department_id'(nv,ov) {
      if (nv){
        if (nv.length == 2){
          this.main_data.department_id = [this.main_data.department_id[1]]
        }
      } else if (nv == false){
    
      }
    }
  },
}
</script>

<style scoped>

</style>